module.exports = __webpack_public_path__ + "img/ES0229.0b01ba4c.png";